import {
    Button,
    Card,
    Input,
    Modal,
    notification,
    Skeleton,
    Form,
    Switch,
    Select,
    Checkbox,
    Popconfirm,
    Radio,
} from "antd";
import { useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import {
    DeleteTwoTone,
    EditTwoTone,
    PlusOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import "./List.css";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { encrypt, getUserRole, Roles, vendorTypes } from "../../services/util";

const { Option } = Select;

const platforms = [
    { key: 1, name: "Analytics" },
    { key: 2, name: "Vendor Portal" },
    { key: 3, name: "Jira" },
    { key: 4, name: "GIT" },
    { key: 5, name: "Dynatrace" },
    /* { key: 6, name: "Splunk" },
    { key: 7, name: "Connectwise" }, */
];

const VendorRoles = [
    { key: 1, name: "Admin" },
    { key: 2, name: "Support" },
    { key: 3, name: "Sales" },
    { key: 5, name: "Trainee" },
];

function UserList() {
    const [form] = Form.useForm();
    const [authForm] = Form.useForm();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const userRole = getUserRole();
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
    });
    const [hotelOptions, setHotelOptions] = useState([]);
    const [userData, setUsersData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [authVisible, setAuthVisible] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [title, setTitle] = useState("Edit");
    const [userRoleOption, setUserRoleOption] = useState(Roles);
    const columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            sorter: () => {},
            width: 100,
        },
        {
            title: "First Name",
            dataIndex: "first_name",
            key: "first_name",
            sorter: () => {},
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            key: "last_name",
            sorter: () => {},
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: () => {},
        },
        {
            title: "Status",
            render: (text, record) => (
                <Switch
                    size="small"
                    id={record.id}
                    defaultChecked={record.is_active}
                    disabled
                />
            ),
        },
        {
            title: "Role",
            dataIndex: "role_id",
            key: "role_id",
            render: (text, record) => (
                <span>
                    {record.platform == 1
                        ? getUserRole(text)
                        : VendorRoles.find(({ key }) => key == text)?.name}
                </span>
            ),
        },
        {
            title: "Vendor User Type",
            dataIndex: "vendor_user_type",
            key: "vendor_user_type",
            render: (text, record) => (
                <span>
                    {record.platform == 2
                        ? text == 1
                            ? "Master"
                            : "Hotel"
                        : "-"}
                </span>
            ),
            width: "10%",
        },
        {
            title: "Platform",
            dataIndex: "platform",
            key: "platform",
            filters: [
                ...platforms.map((v) => {
                    return { text: v.name, value: v.key };
                }),
            ],
            render: (text) => platforms.find(({ key }) => key == text).name,
        },
        {
            title: "Action",
            fixed: "right",
            width: 75,
            render: (text, record) => {
                return (
                    <>
                        {getUserRole(record.role_id) !== "Super Admin" &&
                            staff_id != record.id && (
                                <>
                                    {(userRole == "Super Admin" ||
                                        userRole == "Admin") && (
                                        <DeleteTwoTone
                                            className="actionIcon actionIconDelete"
                                            onClick={() =>
                                                openAuthModel(record.id)
                                            }
                                        />
                                    )}
                                    {record.platform == 1 && (
                                        <EditTwoTone
                                            className="actionIcon"
                                            id={record.id}
                                            details={JSON.stringify(record)}
                                            onClick={editUser}
                                        />
                                    )}
                                </>
                            )}
                    </>
                );
            },
        },
    ];

    const {
        status: userStatus,
        data: userRes,
        refetch: getUser,
    } = useQuery(
        "dashboard-users",
        async () => {
            return await HTTP("/users/getUsers", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: hotelOptionStatus,
        data: hotelOptionRes,
        refetch: getHotelOptions,
    } = useQuery(
        "front-desk-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getUser();
        getHotelOptions();
    }, []);

    useEffect(() => {
        if (hotelOptionStatus == "success") {
            const { data: hotelOptionData } = hotelOptionRes;
            setHotelOptions(hotelOptionData);
        }
    }, [hotelOptionStatus, hotelOptionRes]);

    useEffect(() => {
        getUser();
    }, [formData]);

    useEffect(() => {
        if (userStatus === "success") {
            const { data: userData, total } = userRes;
            setUsersData(userData);
            setTotalRecords(total);
        }
    }, [userStatus, userRes]);

    async function deleteUser(formData) {
        const { success, message } = await HTTP("/users/deleteUsers", formData);
        if (success === 0) {
            notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: "Delete action performed successfully.",
            });
            getUser();
        }
        closeAuthModel();
    }

    function openAuthModel(id) {
        authForm.setFieldsValue({ id });
        setAuthVisible(true);
    }

    function updateUserRolesFromPlatform(platform) {
        setUserRoleOption(platform == 2 ? VendorRoles : Roles);
    }

    function updateUserRoleFormVendorUserType(vendor_user_type) {
        const tempVendorRole = [...VendorRoles];
        if (vendor_user_type == 1) {
            setUserRoleOption(tempVendorRole.slice(0, 1));
        } else {
            setUserRoleOption(tempVendorRole);
        }
    }

    function editUser(e) {
        if (getUserRole() !== "Super Admin" && getUserRole() !== "Admin") {
            return notification["error"]({
                message: "You are not allowed to perform this action.",
            });
        }
        setUserRoleOption(Roles);
        const details = JSON.parse(e.currentTarget.getAttribute("details"));
        setTitle("Edit");
        details.vendor_user_type =
            details.platforms == 2 ? details.vendor_user_type : "";
        form.setFieldsValue(details);
        setVisible(true);
    }

    function openAddUserModel() {
        setTitle("Add");
        form.resetFields();
        form.setFieldsValue({ platform: 1 });
        setVisible(true);
    }

    function closeModel() {
        setVisible(false);
        form.resetFields();
    }

    function closeAuthModel() {
        setAuthVisible(false);
        authForm.resetFields();
    }

    async function handleSubmit(formData) {
        if (!formData.hotel_ids) formData.hotel_ids = [];
        formData.all_selected = formData.hotel_ids.length == 0;
        formData.staff_id = staff_id;
        setVisible(false);
        form.resetFields();
        let url;
        if (formData.id) {
            if (formData.setPassword)
                formData.password = encrypt(formData.password);
            url = "/users/editUsers";
        } else {
            delete formData.id;
            formData.password = encrypt(formData.password);
            url = "/users/addUsers";
        }
        const { success, message } = await HTTP(url, formData);
        let type = "info";
        if (success === 0) {
            type = "error";
        }
        notification[type]({
            message: message,
        });
        getUser();
    }

    function handleTableChange(pagination, filters, sorter, extra) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
            ...(filters.platform ? { filters } : { filters: {} }),
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        const formData = {
            staff_id,
            ...others,
        };
        setFormData(formData);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (userRole === "Super Admin" ||
                            userRole === "Admin") && (
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={openAddUserModel}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        )
                    }
                />
                {userStatus == "loading" || userStatus == "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={userData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="id"
                        className="dashboard-table"
                        isScroll
                    />
                )}
            </Card>
            <Modal
                title={title}
                open={visible}
                footer=""
                onCancel={closeModel}
                destroyOnClose={true}
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Platform"
                        name="platform"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Platform!",
                            },
                        ]}
                    >
                        <Select onChange={updateUserRolesFromPlatform}>
                            {platforms.map(({ key, name }) => (
                                <Option
                                    key={key}
                                    value={key}
                                    disabled={key > 5}
                                >
                                    {name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("platform") < 3 && (
                                <>
                                    <Form.Item
                                        label="Fisrt Name"
                                        name="first_name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input first name!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="First name"
                                            id="first_name"
                                            className="upcoming-form-inputs"
                                        ></Input>
                                    </Form.Item>
                                    <Form.Item
                                        label="Last Name"
                                        name="last_name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input last name!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Last Name"
                                            id="last_name"
                                            className="upcoming-form-inputs"
                                        ></Input>
                                    </Form.Item>
                                </>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("platform") == 4 && (
                                <>
                                    <Form.Item
                                        label="Name"
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please input name!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Name"
                                            id="name"
                                            className="upcoming-form-inputs"
                                        ></Input>
                                    </Form.Item>
                                    <Form.Item
                                        label="User Name"
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input user name!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="User Name"
                                            id="username"
                                            className="upcoming-form-inputs"
                                        ></Input>
                                    </Form.Item>
                                </>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Please enter email!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Email"
                            id="email"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.id !== currentValues.id ||
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("id") != undefined &&
                            getFieldValue("platform") != 3 &&
                            getFieldValue("platform") != 5 && (
                                <Form.Item
                                    label="Set Password"
                                    name="setPassword"
                                    valuePropName="checked"
                                >
                                    <Checkbox id="setPassword" />
                                </Form.Item>
                            )
                        }
                    </Form.Item>

                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.setPassword !==
                                currentValues.setPassword ||
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            (getFieldValue("setPassword") == true ||
                                getFieldValue("id") == undefined) &&
                            getFieldValue("platform") != 3 &&
                            getFieldValue("platform") != 5 &&
                            getFieldValue("platform") != 6 ? (
                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter password!",
                                        },
                                        {
                                            pattern:
                                                /^(?=.*\d)(?=.*[~!@#$%^&*()\-_=+<>,.?/;:"'{}|\\[\]])(?!.*\s)(?=.*[A-Z])(?=.*[a-z]).{8,16}$/,
                                            message:
                                                "Password must be 8-16 characters long and contain at least one lowercase letter, one uppercase letter, one special character and a number.",
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        type="password"
                                        placeholder="Password"
                                        id="password"
                                        className="upcoming-form-inputs"
                                    ></Input.Password>
                                </Form.Item>
                            ) : (
                                ""
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("platform") == 1 && (
                                <Form.Item
                                    label="Status"
                                    name="is_active"
                                    valuePropName="checked"
                                >
                                    <Switch
                                        placeholder="Status"
                                        id="is_active"
                                        className="upcoming-form-inputs"
                                    ></Switch>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform ||
                            prevValues.vendor_user_type !==
                                currentValues.vendor_user_type
                        }
                    >
                        {({ getFieldValue }) =>
                            (getFieldValue("platform") < 3 ||
                                getFieldValue("vendor_user_type") == 2) && (
                                <Form.Item
                                    label="Role"
                                    name="role_id"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Role!",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator() {
                                                const roleAvailable =
                                                    userRoleOption.find(
                                                        ({ key }) =>
                                                            key ==
                                                            getFieldValue(
                                                                "role_id",
                                                            ),
                                                    );
                                                if (!roleAvailable) {
                                                    return Promise.reject(
                                                        "This Role is Not Available. Please Select Other..!",
                                                    );
                                                }
                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                    valuePropName="defaultValue"
                                >
                                    <Select
                                        allowClear
                                        placeholder="Role"
                                        id="role_id"
                                        className="upcoming-form-inputs"
                                        disabled={
                                            title == "Add"
                                                ? false
                                                : title == "Edit" &&
                                                  userRole == "Super Admin"
                                                ? false
                                                : true
                                        }
                                    >
                                        {userRoleOption.map((r) => (
                                            <Option key={r.key}>
                                                {r.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("platform") == 1 && (
                                <Form.Item
                                    label="Hotels"
                                    name="hotel_ids"
                                    valuePropName="defaultValue"
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {hotelOptions.map((h) => (
                                            <Option
                                                key={h.hotel_id}
                                                value={h.hotel_id}
                                            >
                                                {`${h.hotel_id} - ${h.hotel_name}`}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.platform !== currentValues.platform
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("platform") == 2 && (
                                <Form.Item
                                    label="Vendor User Type"
                                    name="vendor_user_type"
                                    valuePropName="defaultValue"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please Select Vendor User Type..!",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Vendor User Type"
                                        id="vendor_user_type"
                                        allowClear
                                        onChange={
                                            updateUserRoleFormVendorUserType
                                        }
                                    >
                                        <Option value={1}>Master User</Option>
                                        <Option value={2}>Hotel User</Option>
                                    </Select>
                                </Form.Item>
                            )
                        }
                    </Form.Item>

                    <Form.Item label="Id" name="id" className="hidden">
                        <Input
                            id="id"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title={title}
                open={authVisible}
                footer=""
                onCancel={closeAuthModel}
                destroyOnClose={true}
            >
                <Form
                    form={authForm}
                    onFinish={(values) => {
                        deleteUser({
                            ...values,
                            password: encrypt(values.password),
                            staff_id,
                        });
                    }}
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Please provide email..!",
                            },
                        ]}
                    >
                        <Input id="email" className="upcoming-form-inputs" />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please provide password..!",
                            },
                        ]}
                    >
                        <Input.Password
                            id="password"
                            className="upcoming-form-inputs"
                        />
                    </Form.Item>
                    <Form.Item name="id" className="hidden">
                        <Input
                            id="id"
                            className="upcoming-form-inputs"
                            disabled
                        />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { UserList };
